export default __webpack_public_path__ + "static/media/2001.036f0ffa.png";